__turbopack_context__.v({
  "className": "denton_b995d046-module__RSBxgW__className",
  "variable": "denton_b995d046-module__RSBxgW__variable",
});
